import axios from 'axios';

const api = axios.create({ baseURL: window.Config.BASE_URL });

export { api };

export default {
	carregar: () => api.get('permisys/usuarioAutenticado'),

	login: ({ usuario, senha }) => api.post('/permisys/efetuarLogon', { usuario, senha }),
	logout: () => api.post('/permisys/efetuarLogout')
};